module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-26.02cae4e9.png";